import * as z from "zod/v4";

export const wasteWorkOrder = {
  name: "wasteWorkOrder" as const,
  input: z.object({
    workOrderIds: z.array(z.string()),
    reason: z.enum(["damaged", "qa_fail", "other"]),
  }),
  output: z.object({ success: z.boolean() }),
};
